import { WidgetNetworkErrors } from '../types';

export type ApiException = {
    code: number;
    body: any;
};

export const isApiError = (error: any): error is ApiException =>
    typeof error === 'object' && 'code' in error && typeof error.code === 'number' && 'body' in error;

export const getNetworkStatus = (error: any): number | undefined => {
    if (isApiError(error)) return error.code;
    return undefined;
};

export const isNotAuthorized = (error: any): boolean => getNetworkStatus(error) === 401;

export const isNotFound = (error: any): boolean => getNetworkStatus(error) === 404;

export const isUnprocessableEntity = (error: any): boolean => getNetworkStatus(error) === 422;

export const getNetworkErrorsDescriptor = (error: any): WidgetNetworkErrors => {
    if (isNotAuthorized(error)) return { code: 'ERRNOACCESS' };
    return { code: 'ERRUNKNOWN' };
};
